<template>
  <div class="edit-expense-wrap">
    <a href="#" style="text-decoration: none" @click.prevent="modalShow = !modalShow">
      <slot/>
    </a>
    <b-modal v-model="modalShow"
             hide-footer
             title="Edit expense"
             no-fade
             @hidden="
               SET_MODAL_CLOSED()
               resetForm()"
             @shown="
             SET_MODAL_OPEN()"
    >
      <b-tabs>

        <b-tab title="Details" active>
          <br>
          <div class="row">
            <div class="col-md-6 offset-md-4">
              <div v-if="error.label" class="alert alert-danger">{{ error.label }}</div>
              <div v-if="message.label" class="alert alert-success">{{ message.label }}</div>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-4 col-form-label text-md-right">Label</label>
            <div class="col-md-6">
              <input ref="expenseLabel"
                     v-model="form.label"
                     :class="{ 'is-invalid': errors.label }"
                     class="form-control"
                     @focus="$event.target.select()"
                     @keyup.enter="submitLabel()"
              >
              <span v-if="errors.label" class="invalid-feedback">
                <div v-for="(error, index) in errors.label.label" :key="index"><strong>{{ error }}</strong></div>
              </span>
            </div>
          </div>
          <div class="form-group row mb-0">
            <div class="col-md-6 offset-md-4 text-center">
              <button type="submit" class="btn btn-primary" @click.prevent="submitLabel()">
                <span v-if="this.$loading.isLoading('saving-expense-label')"><i class="pe pe-spinner fa-spin" aria-hidden="true"/></span> Update
              </button>
            </div>
          </div>
          <div v-if="!expenseOccurrence.isRecurring">
            <hr>
            <div class="row">
              <div class="col-md-6 offset-md-4">
                <div v-if="error.date" class="alert alert-danger">{{ error.date }}</div>
                <div v-if="message.date" class="alert alert-success">{{ message.date }}</div>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-md-4 col-form-label text-md-right">Date</label>
              <div class="col-md-6">
                <input v-if="!form.isNotDaySpecific" id="expenseFixDate" v-model="form.date" :class="{ 'is-invalid': errors.date }" type="date" class="form-control">
                <input v-if="form.isNotDaySpecific" id="expenseFuzzyDate" v-model="form.date" :class="{ 'is-invalid': errors.date }" type="month" class="form-control">
                <span v-if="errors.date" class="invalid-feedback d-block">
                  <div v-for="(error, index) in errors.date.date" :key="index"><strong>{{ error }}</strong></div>
                </span>
              </div>
            </div>
            <div class="form-group row">
              <div class="col-12 text-center">
                <b-form-checkbox :id="'isNotDaySpecificCheckbox' + expenseOccurrence.id"
                                 v-model="form.isNotDaySpecific"
                                 :value="true"
                                 :unchecked-value="false">
                  Not day specific
                </b-form-checkbox>
              </div>
            </div>
            <div class="form-group row mb-0">
              <div class="col-md-6 offset-md-4 text-center">
                <button type="submit" class="btn btn-primary" @click.prevent="submitDate()">
                  <span v-if="this.$loading.isLoading('saving-expense-date')"><i class="pe pe-spinner fa-spin" aria-hidden="true"/></span> Update
                </button>
              </div>
            </div>
          </div>
          <div v-if="expenseOccurrence.isRecurring">
            <hr>
            <div class="form-group row">
              <label class="col-md-4 col-form-label text-md-right">Date (recurrence)</label>
              <div class="col-md-7 text-center text-yellow">
                <span class="form-control">{{ recurrenceRuleStr }}</span>
              </div>
            </div>
          </div>
        </b-tab>

        <b-tab title="Estimate">
          <br>
          <div class="row">
            <div class="col-md-6 offset-md-4">
              <div v-if="error.estimate" class="alert alert-danger">{{ error.estimate }}</div>
              <div v-if="message.estimate" class="alert alert-success">{{ message.estimate }}</div>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-md-4 col-form-label text-md-right">Estimate</label>
            <div class="col-md-6">
              <b-input-group :append="state.ledger.selectedLedger.currency | uppercase">
                <input ref="expenseEstimate"
                       v-model="form.estimate"
                       :class="{ 'is-invalid': errors.estimate }"
                       class="form-control"
                       type="number"
                       pattern="[0-9]*"
                       @focus="$event.target.select()"
                       @keyup.enter="submitEstimate('this')"
                >
              </b-input-group>
              <span v-if="errors.estimate" class="invalid-feedback d-block">
                <div v-for="(error, index) in errors.estimate.estimate" :key="index"><strong>{{ error }}</strong></div>
              </span>
            </div>
          </div>
          <div class="form-group row mb-0">
            <div class="col-md-6 offset-md-4 text-center">
              <b-dropdown v-if="expenseOccurrence.isRecurring" right offset="61px" variant="primary">
                <template slot="button-content">
                  <span v-if="this.$loading.isLoading('saving-expense-estimate')"><i class="pe pe-spinner fa-spin" aria-hidden="true"/></span> <i class="pe pe-repeat" aria-hidden="true"/><span class="btn-inline-text">Update</span>
                </template>
                <b-dropdown-item href="#" @click.prevent="submitEstimate('this')"><i class="pe pe-repeat" aria-hidden="true"/><span class="btn-inline-text">Update</span></b-dropdown-item>
                <b-dropdown-item v-if="expenseOccurrence.isRecurring" href="#" @click.prevent="submitEstimate('thisAndAllFuture')"><i class="pe pe-repeat" aria-hidden="true"/><span class="btn-inline-text">Update this and all future</span></b-dropdown-item>
              </b-dropdown>
              <b-button v-if="!expenseOccurrence.isRecurring" variant="primary" @click.prevent="submitEstimate('this')">
                <span v-if="this.$loading.isLoading('saving-expense-estimate')"><i class="pe pe-spinner fa-spin" aria-hidden="true"/></span><span class="btn-inline-text">Update</span>
              </b-button>
            </div>
          </div>
        </b-tab>

        <b-tab v-if="canRemove" title="Remove" class="expense-remove-tab">
          <br>
          <div class="row">
            <div class="col-md-6 offset-md-4">
              <div v-if="error.destroy" class="alert alert-danger">{{ error.destory }}</div>
            </div>
          </div>
          <div class="form-group row mt-1 mb-0">
            <div class="col-12 text-center">
              <b-dropdown v-if="expenseOccurrence.isRecurring" right offset="57px" variant="danger">
                <template slot="button-content">
                  <i class="pe pe-trash-o" aria-hidden="true"/><span class="btn-inline-text">Remove</span>
                </template>
                <b-dropdown-item href="#" @click.prevent="removeExpenseOccurrence()"><i class="pe pe-trash-o" aria-hidden="true"/><span class="btn-inline-text">Remove</span></b-dropdown-item>
                <b-dropdown-item href="#" @click.prevent="removeCurrentAndFutureExpenseOccurrence()"><i class="pe pe-trash-o" aria-hidden="true"/><span class="btn-inline-text">Remove this and all future</span></b-dropdown-item>
                <b-dropdown-item href="#" @click.prevent="removeAllExpenseOccurrences()"><i class="pe pe-trash-o" aria-hidden="true"/><span class="btn-inline-text">Remove all</span></b-dropdown-item>
              </b-dropdown>
              <b-button v-if="!expenseOccurrence.isRecurring" variant="danger" @click.prevent="removeExpenseOccurrence()">
                <i class="pe pe-trash-o" aria-hidden="true"/><span class="btn-inline-text">Remove</span>
              </b-button>
            </div>
          </div>
        </b-tab>

      </b-tabs>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
let moment = require('moment')
let rrulestr = require('rrule').rrulestr

export default {
  name: 'EditExpense',
  props: {
    expenseOccurrence: {
      required: true
    }
  },
  data () {
    return {
      modalShow: false,
      form: {
        label: this.expenseOccurrence.label,
        estimate: this.expenseOccurrence.estimate,
        date: this.expenseOccurrence.isNotDaySpecific ? moment(this.expenseOccurrence.date, 'YYYY-MM-DD').format('YYYY-MM') : this.expenseOccurrence.date,
        isNotDaySpecific: !!this.expenseOccurrence.isNotDaySpecific
      },
      message: {
        label: '',
        estimate: '',
        date: ''
      },
      error: {
        label: '',
        estimate: '',
        date: '',
        destroy: ''
      },
      errors: {}
    }
  },
  computed: {
    ...mapState({
      state: state => state
    }),
    ledgerId () {
      return this.$route.params.id
    },
    canRemove () {
      if (!this.state.account.me) {
        return false
      }
      return (this.state.account.me.id === this.state.ledger.selectedLedger.owner_id) || (this.expenseOccurrence.createdBy === this.state.account.me.id)
    },
    recurrenceRuleStr () {
      if (this.expenseOccurrence.isRecurring) {
        let str = 'RRULE:'
        str = str + 'INTERVAL=' + this.expenseOccurrence.recurringFrequencyInterval + ';'
        str = str + 'FREQ=' + this.expenseOccurrence.recurringFrequency
        if (this.expenseOccurrence.recurringEnds === 'occurrences' && this.expenseOccurrence.recurringOccurrences) {
          str = str + ';COUNT=' + this.expenseOccurrence.recurringOccurrences
        }
        if (this.expenseOccurrence.recurringEnds === 'date' && this.expenseOccurrence.recurringEndDate) {
          let endDate = moment(new Date(this.expenseOccurrence.recurringEndDate))
          str = str + ';UNTIL=' + endDate.format('YYYYMMDD')
        }
        let rule = rrulestr(str)
        return rule.toText()
      } else {
        return ''
      }
    }
  },
  watch: {
    'form.isNotDaySpecific': function (val) {
      if (val) {
        this.form.date = moment(this.form.date, 'YYYY-MM-DD').format('YYYY-MM')
      } else {
        this.form.date = this.expenseOccurrence.date
      }
    }
  },
  beforeDestroy () {
    if (this.state.ui.modalOpen) {
      this.SET_MODAL_CLOSED()
    }
  },
  methods: {
    ...mapMutations([
      'SET_MODAL_OPEN',
      'SET_MODAL_CLOSED'
    ]),
    ...mapActions([
      'updateExpenseLabel',
      'updateExpenseDate',
      'updateExpenseEstimate',
      'destroyExpenseOccurrence',
      'destroyAllExpenseOccurrences',
      'destroyCurrentAndFutureExpenseOccurrence'
    ]),
    resetForm () {
      this.error = {}
      this.errors = {}
      this.message = {}
      this.form.label = this.expenseOccurrence.label
      this.form.estimate = this.expenseOccurrence.estimate
      this.form.date = this.expenseOccurrence.isNotDaySpecific ? moment(this.expenseOccurrence.date, 'YYYY-MM-DD').format('YYYY-MM') : this.expenseOccurrence.date
      this.form.isNotDaySpecific = !!this.expenseOccurrence.isNotDaySpecific
    },
    submitLabel () {
      this.$loading.startLoading('saving-expense-label')
      this.errors = {}
      this.updateExpenseLabel({ 'ledgerId': this.ledgerId, 'expenseId': this.expenseOccurrence.expenseId, 'label': this.form.label })
        .then((data) => {
          this.error.label = ''
          this.message.label = data.message
          this.$loading.endLoading('saving-expense-label')
        })
        .catch((data) => {
          this.message.label = ''
          this.error.label = data.message
          this.errors.label = data.errors || {}
          this.$loading.endLoading('saving-expense-label')
        })
    },
    submitDate () {
      this.$loading.startLoading('saving-expense-date')
      this.errors = {}
      this.updateExpenseDate({ 'ledgerId': this.ledgerId, 'expenseId': this.expenseOccurrence.expenseId, 'expenseDateId': this.expenseOccurrence.id, 'date': this.form.date, 'isNotDaySpecific': this.form.isNotDaySpecific })
        .then((data) => {
          this.error.date = ''
          this.message.date = data.message
          this.$loading.endLoading('saving-expense-date')
        })
        .catch((data) => {
          this.message.date = ''
          this.error.date = data.message
          this.errors.date = data.errors || {}
          this.$loading.endLoading('saving-expense-date')
        })
    },
    submitEstimate (updateType) {
      this.$loading.startLoading('saving-expense-estimate')
      this.errors = {}
      this.updateExpenseEstimate({ 'ledgerId': this.ledgerId, 'expenseId': this.expenseOccurrence.expenseId, 'expenseDateId': this.expenseOccurrence.id, 'estimate': this.form.estimate, updateType: updateType })
        .then((data) => {
          this.error.estimate = ''
          this.message.estimate = data.message
          this.$loading.endLoading('saving-expense-estimate')
        })
        .catch((data) => {
          this.message.estimate = ''
          this.error.estimate = data.message
          this.errors.estimate = data.errors || {}
          this.$loading.endLoading('saving-expense-estimate')
        })
    },
    removeExpenseOccurrence () {
      let self = this
      this.$swal({
        title: 'Are you sure?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        animation: false
      }).then((result) => {
        if (result.value) {
          self.destroyExpenseOccurrence({ 'ledgerId': self.state.ledger.selectedLedger.id, 'expenseId': this.expenseOccurrence.expenseId, 'expenseDateId': this.expenseOccurrence.id })
            .then((data) => {
              self.error.destory = ''
              self.modalShow = false
            })
            .catch((data) => {
              self.error.destory = data.message
            })
        }
      })
    },
    removeCurrentAndFutureExpenseOccurrence () {
      let self = this
      this.$swal({
        title: 'Are you sure?',
        text: 'This will remove this and all future occurrences of the expense!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        animation: false
      }).then((result) => {
        if (result.value) {
          self.destroyCurrentAndFutureExpenseOccurrence({ 'ledgerId': self.state.ledger.selectedLedger.id, 'expenseId': this.expenseOccurrence.expenseId, 'expenseDateId': this.expenseOccurrence.id })
            .then((data) => {
              self.error.destory = ''
              self.modalShow = false
            })
            .catch((data) => {
              self.error.destory = data.message
            })
        }
      })
    },
    removeAllExpenseOccurrences () {
      let self = this
      this.$swal({
        title: 'Are you sure?',
        text: 'This will remove all occurrences of the expense!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        animation: false
      }).then((result) => {
        if (result.value) {
          self.destroyAllExpenseOccurrences({ 'ledgerId': self.state.ledger.selectedLedger.id, 'expenseId': this.expenseOccurrence.expenseId })
            .then((data) => {
              self.error.destory = ''
              self.modalShow = false
            })
            .catch((data) => {
              self.error.destory = data.message
            })
        }
      })
    }
  }
}
</script>
